<template>
  <select :value="modelValue" class="form-select" @input="$emit('update:modelValue', $event.target.value)">
    <option value="10">
      {{ $t("dia", 10, { count: 10 }) }}
    </option>
    <option :value="monthsAgoInDays(1)">
      {{ $t("mes", 1, { count: 1 }) }}
    </option>
    <option :value="monthsAgoInDays(2)">
      {{ $t("mes", 2, { count: 2 }) }}
    </option>
    <option :value="monthsAgoInDays(3)">
      {{ $t("mes", 3, { count: 3 }) }}
    </option>
    <option :value="monthsAgoInDays(4)">
      {{ $t("mes", 4, { count: 4 }) }}
    </option>
    <option :value="monthsAgoInDays(5)">
      {{ $t("mes", 5, { count: 5 }) }}
    </option>
    <option :value="monthsAgoInDays(6)">
      {{ $t("mes", 6, { count: 6 }) }}
    </option>
    <option :value="monthsAgoInDays(7)">
      {{ $t("mes", 7, { count: 7 }) }}
    </option>
    <option :value="monthsAgoInDays(8)">
      {{ $t("mes", 8, { count: 8 }) }}
    </option>
    <option :value="monthsAgoInDays(9)">
      {{ $t("mes", 8, { count: 8 }) }}
    </option>
    <option :value="monthsAgoInDays(10)">
      {{ $t("mes", 10, { count: 10 }) }}
    </option>
    <option :value="monthsAgoInDays(11)">
      {{ $t("mes", 11, { count: 11 }) }}
    </option>
    <option :value="monthsAgoInDays(12)">
      {{ $t("mes", 12, { count: 12 }) }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    modelValue: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  methods: {
    monthsAgoInDays(monthsAgo) {
      const now = new Date();
      const ago = new Date();
      ago.setMonth(ago.getMonth() - monthsAgo);
      const timeDiff = now.getTime() - ago.getTime();
      return timeDiff / (1000 * 3600 * 24);
    },
  },
};
</script>
